import { http } from '@/utils/request'
import { signRequest } from '@/utils/signRequest'

export interface LoginParams {
  /** 登录账号（手机号） */
  loginUser: string
  /** 短信验证码 */
  code: string
  /** 客户端版本信息 */
  clientVersion?: { client: string }
}

export interface LoginResult {
  token: string
  userId: string
}

export interface UserInfo {
  userId: string
  nickname: string
  avatar: string
  mobile: string
  /** 微信 JSAPI 支付所需的 openid，由静默授权 code 换取 */
  openid?: string
}

/**
 * 发送登录短信验证码（走 auth 域名，签名参数附加 auth_type=sms）
 * TODO url 与入参为占位，待后端联调时确认实际接口地址与字段
 */
export const sendSmsCode = (mobile: string) =>
  signRequest<any>({
    url: `/v1/sms?mobileNum=${mobile}&smsType=2`,
    method: 'POST',
    service: 'api',
    sms: false,
    data: { },
    config: { showLoading: true },
  })

/** 短信验证码登录（走 auth 域名，签名参数附加 auth_type=sms，业务参数仍走请求体） */
export const login = (data: LoginParams) =>
  signRequest<any>({
    url: '/api/client/login',
    method: 'POST',
    service: 'auth',
    sms: false,
    data,
    config: { showLoading: true },
  })

export const smsLogin = (data: LoginParams) =>
  signRequest<any>({
    url: '/api/client/login',
    method: 'POST',
    service: 'auth',
    sms: true,
    data,
    config: { showLoading: true },
  })

/** 获取当前用户信息 */
export const getUserInfo = () => http.get<UserInfo>('/user/info')

/** 退出登录 */
export const logout = () => http.post<void>('/user/logout', undefined, { showError: false })

/**
 * 微信浏览器静默授权：用授权回调拿到的 code 换取 openid
 * TODO url 与参数为占位，待后端联调时确认实际接口地址与出入参
 */
export const getWechatOpenid = (code: string) =>
  http.get<any>('/om/orderapi/orders/wx/openid', { code })

// 获取用户当前产品ID状态
export const fetchUserStageStatus= (data:any) =>
  http.get<any>('/om/orderapi/new/get/user/stage/status', data, { showLoading: true })

// 获取服务器当前时间（秒级），签名参数依赖它
export const getSysTime = () => http.get<{ currentTime: number }>('/v1/systime')
// 1.0续费开关接口
export const getPurchaseFlowConfig = async (data:any) => {
  const res = await http.get(
    `/om/orderapi/new/purchase-flow/config`,
    data
  );
  return res
}
// 根据unionId判断是否存在好友关系
export const getFriendByUnionid = async (data:any) => {
  const res = await http.get(
    `/friend/check-unionId`,
    data
  );
  return res;
};

export const purchaseFlowQualify = async (params:any) => {
  const res = await http.get(
    `/om/orderapi/new/purchase-flow/qualify`,
    params
  );
  return res
}

// 新版登录
export const loginV3Api = (data: LoginParams,auth_type:string) =>
  signRequest<any>({
    url: '/api/client/login/v3',
    method: 'POST',
    service: 'auth',
    sms: false,
    data,
    config: { showLoading: true },
    auth_type
  });